<div class="container p-4">
    <div class="row d-flex justify-content-center">
        <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        <div class="col-12 text-center modal-title">{{title | translate}}</div>
    </div>

    <section>
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs nav-justified">
            <li [ngbNavItem]="1">
                <a ngbNavLink>Info</a>
                <ng-template ngbNavContent>
                    <section *ngIf="request">
                        <app-dynamic-form [formName]="'stagingForm'" [formData]="formData!" [form]="formData!" [disabled]="false" (formSubmit)="onEvent('formSubmit', $event)" (formChange)="onEvent('formChange', $event)" (formValidation)="onEvent('formValidation', $event)" #dynamicForm>
                        </app-dynamic-form>
                    </section>
                </ng-template>
            </li>
            <li [ngbNavItem]="2">
                <a ngbNavLink>{{'DETAIL_REQUEST' | translate}}</a>
                <ng-template ngbNavContent>
                    <app-request-detail [dataSource]="pending$"></app-request-detail>
                </ng-template>
            </li>
        </ul>

        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </section>

    <div class="mt-4 d-flex justify-content-center" *ngIf="hasWithdrawModal">
        <button mat-flat-button class="btn-action error" (click)="withdrawModal()">Revoca la richiesta</button>
    </div>


</div>
